/* each section active state */

import type { CarConfigLabelType } from "../labels";
import type { WinterWheelType } from "../../../../../common-deprecated/types/CommonTypes";

export enum CarConfigConfigureSection {
    Engine = "carconfig-engine",
    Colour = "carconfig-colour",
    Wheels = "carconfig-wheels",
    Upholstery = "carconfig-upholstery",
    Packs = "carconfig-packs",
    Charging = "carconfig-charging",
    Services = "carconfig-services",
    Summary = "carconfig-summary",
}

export enum CarConfigHighlightSection {
    // Fixed header section is needed in highlights
    SectionHeader = "section-header",
}

export enum AvailableInOtherGradeModalType {
    Wheel = "availableInOtherGradesWheels",
    Colour = "availableInOtherGradesColour",
    Engine = "availableInOtherGradesEngine",
    Upholstery = "availableInOtherGradesUpholstery",
}

type carConfigsectionsAriaLabelMappingType = {
    [key in CarConfigConfigureSection]: CarConfigLabelType;
};

export const carConfigsectionsAriaLabelMapping: carConfigsectionsAriaLabelMappingType = {
    [CarConfigConfigureSection.Engine]: "carConfigEngine",
    [CarConfigConfigureSection.Colour]: "carConfigColour",
    [CarConfigConfigureSection.Wheels]: "carConfigWheels",
    [CarConfigConfigureSection.Upholstery]: "carConfigUpholstery",
    [CarConfigConfigureSection.Packs]: "carConfigPacksAndExtras",
    [CarConfigConfigureSection.Services]: "carConfigServicesTitle",
    [CarConfigConfigureSection.Charging]: "carConfigCharging",
    [CarConfigConfigureSection.Summary]: "carConfigOverviewTitle",
};
export type EuLabelIcons = keyof NonNullable<WinterWheelType["euLabelProperties"]>;
